<template>
  <div class="warp">
    <!-- 模拟手机预览 -->
    <div class="preview-wrapper">
      <iframe class="preview-content" :src="url" frameborder="0" />
    </div>
  </div>
</template>

<script>
const urls = ['simulation/douyin/register/index', 'simulation/douplus', 'simulation/blessingBag', 'simulation/douyinchuchuang/index']
export default {
  computed: {
    url() {
      return process.env.BASE_URL + urls[this.$route.query.type];
    }
  }
};
</script>

<style lang="less" scoped>
.warp {
  position: relative;
  height: 100vh;
  .preview-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 377px;
    height: 812px;
    background-image: url("../../../assets/images/simulation/phone.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .preview-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 350px;
    height: 660px;
    overflow: auto;
  }
}
</style>